import { BroadcastChannel } from 'broadcast-channel';
import type { GithubAuthPayload } from 'src/components/AuthNew/hooks/useGithubAuth';

export const GithubHandler = () => {
  const channel = new BroadcastChannel('auth-github-code');

  const payload = [
    ...new URLSearchParams(window.location.search).entries(),
  ].reduce((acc, paramTuple) => {
    // eslint-disable-next-line prefer-destructuring
    acc[paramTuple[0]] = paramTuple[1];
    return acc;
  }, {} as GithubAuthPayload);

  channel.postMessage({
    success: !payload.error,
    payload,
  });

  setTimeout(() => {
    window.close();
  }, 250);
};
